import React from 'react';

class PrintMenu extends React.Component {
    onClick = () => {
        this.close();
        setTimeout(() => window.print(), 1);
    };

    close = () => {
        if (this.props.closeModal) {
            this.props.closeModal();
        }
    };

    render() {
        return (
            <div className="mt3 right-align">
                <span className="react-modal-close btn-secondary mr1" onMouseDown={this.close}>Cancel</span>
                <span onMouseDown={this.onClick} className="btn btn-primary">Print page</span>
            </div>
        );
    }
}

export default PrintMenu;
